var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center mt-3 mb-3"},[_c('b-spinner',{attrs:{"variant":_vm.variant,"label":"Loading..."}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }